import { IThunkAction } from 'types/IThunkAction';
import { startLoading, stopLoading } from 'client/_redux/actions/loading';
import * as CategoryTourService from 'client/_redux/services/categoryTour';
import {
  AddCategoryTourTypes,
  GetCategoryTourTypes,
  getAllCategoryTourTypes,
  deleteCategoryTourTypes,
  GetCategoryTourByIdTypes,
} from 'client/_redux/types/categoryTourTypes';
import { toast } from 'react-toastify';
import { errorHandler } from 'client/helpers/errorHandler';
import ICategoryTourForm from 'client/models/ICategoryTourForm';

// Ajouter une nouvelle catégorie de tour
export const addCategoryTour: (values: ICategoryTourForm) => IThunkAction = (values) => async (
  dispatch,
) => {
  dispatch(startLoading());
  try {
    const response = await CategoryTourService.addCategoryTour()(values);

    dispatch({ type: AddCategoryTourTypes.ADD_CATEGORY_TOUR_SUCCESS, payload: response.data });
    dispatch(getAllCategoryTours());
    toast('Catégorie de tour ajoutée avec succès !', { type: 'success' });
  } catch (error) {
    dispatch({ type: AddCategoryTourTypes.ADD_CATEGORY_TOUR_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

// Mettre à jour une catégorie de tour
export const updateCategoryTour: (
  categoryTourId: string,
  values: Partial<ICategoryTourForm>,
) => IThunkAction = (categoryTourId, values) => async (dispatch) => {
  dispatch(startLoading());
  try {
    const response = await CategoryTourService.updateCategoryTour()(categoryTourId, values);

    dispatch({
      type: AddCategoryTourTypes.UPDATE_CATEGORY_TOUR_SUCCESS,
      payload: response.data,
    });
    dispatch(getAllCategoryTours());
    toast('Catégorie de tour mise à jour avec succès !', { type: 'success' });
  } catch (error) {
    dispatch({ type: AddCategoryTourTypes.UPDATE_CATEGORY_TOUR_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

// Supprimer une catégorie de tour
export const deleteCategoryTourById: (categoryTourId: string) => IThunkAction = (
  categoryTourId,
) => async (dispatch) => {
  dispatch(startLoading());
  try {
    await CategoryTourService.deleteCategoryTourById()(categoryTourId);

    dispatch({
      type: deleteCategoryTourTypes.CATEGORY_TOUR_DELETE_SUCCESS,
      payload: categoryTourId,
    });
    dispatch(getAllCategoryTours());
    toast('Catégorie de tour supprimée avec succès', { type: 'success' });
  } catch (error) {
    dispatch({ type: deleteCategoryTourTypes.CATEGORY_TOUR_DELETE_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

// Récupérer toutes les catégories de tours
export const getAllCategoryTours = (filter?: {
  countryLetter?: string;
  category?: string;
}): IThunkAction => async (dispatch) => {
  dispatch(startLoading());
  try {
    const allCategoryTours = await CategoryTourService.getAllCategoryTours(filter)();

    dispatch({
      type: getAllCategoryTourTypes.CATEGORY_TOUR_SUCCESS,
      payload: allCategoryTours.data,
    });
  } catch (error) {
    dispatch({ type: getAllCategoryTourTypes.CATEGORY_TOUR_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

// Récupérer une catégorie de tour par ID
export const getCategoryTourById: (categoryTourId: string) => IThunkAction = (
  categoryTourId,
) => async (dispatch) => {
  dispatch(startLoading());
  try {
    const categoryTour = await CategoryTourService.getCategoryTourById()(categoryTourId);

    dispatch({
      type: GetCategoryTourByIdTypes.CATEGORY_TOUR_BYID_SUCCESS,
      payload: categoryTour.data,
    });
  } catch (error) {
    dispatch({ type: GetCategoryTourByIdTypes.CATEGORY_TOURBYID_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

// Récupérer une catégorie de tour par slug
export const getCategoryTourBySlug: (slug: string) => IThunkAction = (slug) => async (
  dispatch,
) => {
  dispatch(startLoading());
  try {
    const categoryTour = await CategoryTourService.getCategoryTourBySlug()(slug);

    dispatch({
      type: GetCategoryTourByIdTypes.CATEGORY_TOUR_BYID_SUCCESS,
      payload: categoryTour.data,
    });
  } catch (error) {
    dispatch({ type: GetCategoryTourByIdTypes.CATEGORY_TOURBYID_FAILURE });
    errorHandler(error);
  }
  dispatch(stopLoading());
};

// Toggle favori sur une catégorie de tour
export const toggleFavorCategoryTour: (categoryTourId: string) => IThunkAction = (
  categoryTourId,
) => async (dispatch) => {
  dispatch(startLoading());
  try {
    const response = await CategoryTourService.toggleFavorCategoryTour()(categoryTourId);

    dispatch({
      type: AddCategoryTourTypes.UPDATE_CATEGORY_TOUR_SUCCESS,
      payload: response.data,
    });
    toast('Favori mis à jour !', { type: 'success' });
  } catch (error) {
    errorHandler(error);
  }
  dispatch(stopLoading());
};

// Réinitialiser les données de catégorie
export const resetCategoryTour = (): IThunkAction => async (dispatch) => {
  dispatch({ type: GetCategoryTourTypes.RESET_CATEGORY_TOUR });
};
